import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import OpenAIFilledSvg from "@ant-design/icons-svg/es/asn/OpenAIFilled";
import AntdIcon from "../components/AntdIcon";
var OpenAIFilled = function OpenAIFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: OpenAIFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  OpenAIFilled.displayName = 'OpenAIFilled';
}
export default /*#__PURE__*/React.forwardRef(OpenAIFilled);